import { atom, useAtomValue, useSetAtom } from 'jotai';

// 临时存储登录手机号，用于找回密码进行回填
export const saveTempPhone = atom<{ countryCode: General.PhoneRegionCodes; mobile: string }>({
  countryCode: '+86',
  mobile: '',
});

export const useSaveTempPhone = () => {
  return useAtomValue(saveTempPhone);
};

export const useSetSaveTempPhone = () => {
  return useSetAtom(saveTempPhone);
};
